import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M45.583 23.025a1.609 1.609 0 0 0-.054-.056l-4.217-4.056a.958.958 0 0 1 .002-1.378 1.018 1.018 0 0 1 1.414.002l4.217 4.055a3.352 3.352 0 0 1-.004 4.823l-4.234 4.05a1.02 1.02 0 0 1-1.414 0 .958.958 0 0 1 0-1.38l4.234-4.05.059-.06H28.5c-.552 0-1-.437-1-.975a.988.988 0 0 1 1-.975h17.083Zm-13.586 9.76a.991.991 0 0 1 1.054-.92.984.984 0 0 1 .942 1.03c-.033.578-.145 1.94-.336 4.1-.292 3.297-2.986 5.915-6.39 6.215a81.5 81.5 0 0 1-7.142.29c-2.625 0-5.048-.1-7.272-.301-3.403-.308-6.092-2.93-6.376-6.228C6.159 33.283 6 28.98 6 24.063c0-4.987.163-9.36.49-13.121.291-3.348 3.058-5.991 6.52-6.236 1.951-.137 4.323-.206 7.115-.206 2.733 0 5.063.066 6.99.198 3.465.237 6.238 2.877 6.534 6.226.198 2.238.258 2.435.294 3.048A.984.984 0 0 1 33 15a.991.991 0 0 1-1.054-.92c-.034-.585-.093-.772-.29-2.988-.21-2.39-2.195-4.279-4.68-4.45-1.877-.128-4.161-.192-6.85-.192-2.748 0-5.073.067-6.972.201-2.484.176-4.463 2.067-4.671 4.455C8.161 14.81 8 19.128 8 24.063c0 4.867.157 9.116.47 12.744.203 2.353 2.126 4.23 4.568 4.45a79.17 79.17 0 0 0 7.087.293c2.516 0 4.836-.094 6.961-.282 2.442-.215 4.37-2.088 4.578-4.44.19-2.139.3-3.492.333-4.044Z"
    }
  )
);
var SvgLogoutOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LogoutOutlined_default = SvgLogoutOutlined;

export { LogoutOutlined_default as default };
